// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"SX-z","sponsoredTooltipWrapper":"TX-z","sponsoredTooltip":"UX-z","newCard":"VX-z"};